import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ChatApiService {
    @Output() tokenExpired: EventEmitter<any> = new EventEmitter();

    public readonly apiUrl = environment.apiUrl;
    private readonly apiKey = environment.apiKey;

    public readonly apiUrlLive = environment.apiUrlLive;
    public readonly apiUrlTest = environment.apiUrlTest;

    constructor(private http: HttpClient) {

    }

    public getTestUser(id): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}/public/testuser/view/${id}`
        );
    }

    public getChatForSupervisor(supervisor): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}/private/chat/supervisor/${supervisor}`
        );
    }
    public getChatForCustomer(email, orderHash): Observable<any[]> {
        const headers = new HttpHeaders({
            
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/customer`,
                { email, orderHash },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public sendChatMessage(chat, message) {
        const headers = new HttpHeaders({
            
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/private/chat/send-message`,
                { chat, message },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public updateChatReadAt(email, from, id): Observable<any[]> {
        const headers = new HttpHeaders({
            
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/update-read`,
                { email, from, id },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateChatDeletedAt(email, from, id): Observable<any[]> {
        const headers = new HttpHeaders({
            
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/update-deleted`,
                { email, from, id },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public getContactData(): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}/private/addresses/`
        );
    }

    public sendMessage(message) {
        console.log(275, message);
        const headers = new HttpHeaders({
            
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/private/message/send`,
                {
                    message
                },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public updateOrderStatus(orderId, status) {
        const headers = new HttpHeaders({
            
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/private/order/status`,
                { orderId, status },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public exportBueroPlus(order) {
        const headers = new HttpHeaders({
            
        });
        return this.http
            .get<any>(
                `${this.apiUrl}/private/order/export/${order.orderHash}`,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    
}
